import React from "react";
import "./FacilitiesPage.css";

const FACILITIES = [
  {
    title: "Gymnasium",
    description:
      "A fully equipped fitness center for residents to work out at their own pace, without needing to step outside the community.",
  },
  {
    title: "Swimming Pool",
    description:
      "A dedicated pool for relaxation and recreation, popular with residents of all ages, especially during warmer months.",
  },
  {
    title: "Clubhouse",
    description:
      "A shared indoor space for community gatherings, events, and everyday socializing among residents.",
  },
  {
    title: "Guest Suites",
    description:
      "A waiting lounge and guest accommodation area exclusively for residents, so visiting family and friends have a comfortable place to stay or wait.",
  },
  {
    title: "Children's Play Area",
    description:
      "A safe, dedicated outdoor space where kids can play under supervision, separate from vehicle and pedestrian traffic.",
  },
  {
    title: "Jogging Track",
    description:
      "A landscaped track around the property for residents who want a safe, dedicated space for a run or walk at any time of day.",
  },
  {
    title: "Tennis Court",
    description:
      "An on-site court for residents who enjoy tennis, without needing to book time at an external facility.",
  },
  {
    title: "Landscaped Gardens & Sunken Garden",
    description:
      "Spread across several acres of green open space, the community features landscaped surroundings and a large sunken garden for residents to unwind.",
  },
  {
    title: "Reflexology Park",
    description:
      "A dedicated pathway designed for a therapeutic barefoot walk, aimed at relaxation and light wellness activity.",
  },
  {
    title: "24/7 Security & CCTV Surveillance",
    description:
      "Round-the-clock security personnel and CCTV coverage across common areas, entrances, and the main gate, with intercom connectivity to the security desk from every apartment.",
  },
  {
    title: "Power Backup",
    description:
      "Diesel generator backup with acoustic enclosure covers all common amenities — clubhouse, lifts, common lighting, motors, and pumps — along with load-limited backup for individual apartments.",
  },
];

export default function FacilitiesPage() {
  return (
    <div className="facilities-page">
      <h2>Facilities</h2>
      <p className="facilities-intro">
        Crown Residences offers a wide range of amenities designed for comfortable, modern
        community living.
      </p>

      <div className="facilities-grid">
        {FACILITIES.map((f) => (
          <div className="facility-card" key={f.title}>
            <h3>{f.title}</h3>
            <p>{f.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}